import { CellFilter } from './types'

const notEqual = <T>(filter: T, shift: T, field: keyof T) => {
  const filterValue = filter[field]
  const isFilterDefined = !!filterValue || typeof filterValue === 'number'
  return isFilterDefined && filter[field] !== shift[field]
}

const notEqualish = (
  filter: CellFilter,
  shift: CellFilter,
  field: keyof CellFilter,
) => {
  if (field in filter) {
    return filter[field] != shift[field]
  }

  return false
}

export const byCellFilter =
  (filter: CellFilter, date?: string) =>
  (shift: CellFilter & { date: string }) => {
    if (notEqual(filter, shift, 'bookedCandidateId')) return false
    if (notEqualish(filter, shift, 'rowKey')) return false
    if (notEqual(filter, shift, 'scheduleResourceId')) return false
    if (notEqual(filter, shift, 'startTime')) return false
    if (notEqual(filter, shift, 'endTime')) return false
    if (notEqual(filter, shift, 'breakTime')) return false
    if (notEqualish(filter, shift, 'comment')) return false
    if ('onCallTime' in filter) {
      if (shift.onCallTime && !filter.onCallTime) {
        return false
      }
      if (filter.onCallTime) {
        if (!shift.onCallTime) return false
        if (notEqual(filter.onCallTime, shift.onCallTime, 'type')) return false
        if (notEqual(filter.onCallTime, shift.onCallTime, 'startTime'))
          return false
        if (notEqual(filter.onCallTime, shift.onCallTime, 'endTime'))
          return false
      }
    }
    if (!date) return true
    return date === shift.date
  }
